import React from 'react'
import { Route } from 'react-router-dom'

// A record's route: its page is drawn afresh for each record it matches,
// keyed on the address it matched (/org/group/list/edit/7), so its state --
// the form, the loaded record, its name in the trail and the tab title --
// belongs to one record. Moving straight from one record to another of the
// same kind (a History link, an audit-log link, back and forward) used to
// keep the first record's name, form and buttons while the second loaded,
// and for good when its GET failed (audit F2). A move between the record's
// own tabs (/edit/7/user) matches the same address and keeps the page.
//
// Takes what Route takes: `component`, or children.
export const RecordRoute = ({ component: Component, children, ...props }) =>
  <Route
    {...props}
    render={routeProps => {
      const key = routeProps.match.url
      if (Component) return <Component key={key} {...routeProps} />
      return <React.Fragment key={key}>{children}</React.Fragment>
    }}
  />
